import React from 'react';
import { useLcaDiagram, useProductImpacts } from '../hooks';
import { useParams } from 'react-router-dom';
import { parseNumericId } from 'src/utils/navigation';
import ImpactGridTable from './ImpactGridTable';
import { StyledPanel } from '../styles';
import { StyledTitle } from './styles';
import { useTranslation } from 'react-i18next';
import { Alert } from '@mui/material';
import { getLcaApiErrorMessage } from '../apiErrors';

export default function ImpactGrid() {
  const { t } = useTranslation('lca');
  const { id } = useParams();
  const productId = parseNumericId(id);
  const { data: diagramData } = useLcaDiagram(productId);
  const { data: impactData, error: impactError } = useProductImpacts(productId);
  const impactErrorMessage = getLcaApiErrorMessage(impactError, t);

  return (
    <StyledPanel>
      <StyledTitle>{t('impactGrid.title')}</StyledTitle>
      <br />
      {impactErrorMessage && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {impactErrorMessage}
        </Alert>
      )}
      <ImpactGridTable
        diagramData={diagramData}
        impactData={impactErrorMessage ? undefined : impactData}
        showSummaryRows
      />
    </StyledPanel>
  );
}
